export default __webpack_public_path__ + "static/media/gradient.b8a57aad.jpg";